function DeleteCell({ dataItem, hidden, deleteAction }) {
    if (hidden) return <td></td>;

    function handleDelete() {
        deleteAction(dataItem.id);
    }

    return (
        <td>
            <span
                onClick={handleDelete}
                className="link delete_action float-end text-danger"
                style={{ color: "red" }}
            >
                <i className="fal fa-times"></i>
            </span>
        </td>
    );
}

export default DeleteCell;